import './styles/app.scss';

// start the Stimulus application
import './bootstrap.js';
// Csak a ténylegesen használt Bootstrap komponensek (a teljes 'bootstrap' import
// helyett) — így a Tooltip/Popover/Toast/Tab/ScrollSpy JS nem terheli a fő szálat (TBT).
// Az importálás regisztrálja az adott komponensek data-api-ját (data-bs-toggle stb.).
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/carousel';

// A fejléc görgetés-/tapadás-logikája a `header` Stimulus controllerben él
// (assets/controllers/header_controller.js).

// A Cookie Consent (JS + ~32KB CSS) idle után, dinamikus importtal töltődik,
// így a CSS-e nem render-blokkoló (nem része a kritikus útnak → jobb LCP).
// A gtag 'consent default: denied' inline fut a <head>-ben, ezért a pár száz ms
// késleltetés compliance-szempontból rendben van.
document.addEventListener('turbo:load', () => {
    const initConsent = () => import('./CookieConsentModal').then((m) => new m.default());
    if ('requestIdleCallback' in window) {
        requestIdleCallback(initConsent, { timeout: 2000 });
    } else {
        setTimeout(initConsent, 1);
    }
})

// A `tel:` linkek onclick-jéről hívva — csak a hívás-konverziót lövi.
// Az űrlap-beküldést a `ga` controller méri a form-success blokkon
// (components/Contact.html.twig, components/ContactVertical.html.twig),
// ami kizárólag sikeres beküldés után renderelődik.
window.phoneCallEvent = () => {
    gtag('event', 'conversion_event_phone_call_lead', {});
}
